export const state = () => ({
    rangeTrigger: {
        type: '',
        value: false
    }
})
export const mutations = {
    setRangeTrigger(state, data) {
        state.rangeTrigger = data
    },
}
export default {
    namespaced: true,
    state,
    mutations
}
